/* GLORY DEPT. — gd-product.js
   PDP utilities: size-guide / generic modal toggling.
   Variant selection + add-to-cart remain handled by Horizon. */
(function () {
  'use strict';

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.style.removeProperty('overflow');
  }

  function init() {
    // Open: any [data-gd-modal-open="ID"]; Modal element: [data-gd-modal="ID"]
    document.querySelectorAll('[data-gd-modal-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var id = trigger.getAttribute('data-gd-modal-open');
        var modal = document.querySelector('[data-gd-modal="' + id + '"]');
        if (modal) { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
      });
    });
    document.querySelectorAll('[data-gd-modal]').forEach(function (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.hasAttribute('data-gd-modal-close')) closeModal(modal);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-gd-modal]:not([hidden])').forEach(closeModal);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
